"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useTableSchema_1 = require("./useTableSchema");
function useApplicationsList() {
    const { applicationsList, loading, error } = useTableSchema_1.useTableSchema();
    return {
        applicationsList,
        loading,
        error,
    };
}
exports.useApplicationsList = useApplicationsList;
//# sourceMappingURL=useApplicationsList.js.map